module.exports = __webpack_public_path__ + "img/ic_library_books.493f2d45.svg";